<template>
    <div class="intro-wrapper">
        <img src="../assets/graphics/codex_1/hero_globe.svg" alt="" class="hero-graphic">
        <div class="hero-text-wrapper">
            <h6>4 Layers, 2 Poles and 6 Plates All in 1 Sphere.</h6>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IntroCaro'
    
}
</script>

<style scoped>
    .intro-wrapper {
        margin-top: 62.5vh;
        height: 90vh;
        width: 100%;
        position: relative;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        /* background-color: green; */
    }

    @keyframes rotato {
        0% {transform: rotate(0deg);}
        100% {transform: rotate(360deg);}
    }

    .hero-graphic {
        height: 90vh;
        /* margin: auto; */
        animation: rotato 240s linear infinite normal;
        user-select: none;
        /* position: absolute; */
        /* left: 50%; */
        /* transform: translateX(-50%); */
    }

    h6 {
        font-family: soleil, sans-serif;
        /* text-transform: uppercase; */
    }

    .hero-text-wrapper {
        position: absolute;
        /* top: 50%; */
        /* left: 50%; */
        /* transform: translateX(-50%); */
        text-align: center;
        width: 25%;
        margin: 0;
        display: flex;
        align-items: center;
    }

    .hero-text-wrapper h6 {
        font-size: 24px;
        margin: 0;
        margin-top: 10px;
    }

</style>